import {
  USER_LOGIN,
  USERS_DOWNLOADED,
  USER_DOWNLOADED,
  USERS_FAILED,
  USERS_PENDING,
  USERS_RESET,
  USER_SENDING,
  USERS_RENTERS_DOWNLOADED,
  WAITING_USER_DOWNLOADED,
  WAITING_USERS_DOWNLOADED,
  WAITING_USER_REMOVED,
  USER_RENTER_REMOVED, WAITING_USERS_PENDING,
} from './types';

export const INITIAL_STATE = {
  error: null,
  content: null,
  pending: false,
  sending: false,
  authUser: null,
  waitingUsers: null,
  pendingWU: false,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case USERS_RESET:
      return INITIAL_STATE;
    case USERS_PENDING:
      return {
        ...state,
        error: null,
        pending: true,
      };
    case USERS_DOWNLOADED:
      return {
        ...state,
        error: null,
        pending: false,
        sending: false,
        content: action.payload,
      };
    case USERS_RENTERS_DOWNLOADED: {
      let users = {};
      if (state.content) {
        users = JSON.parse(JSON.stringify(state.content));
        const usersId = Object.keys(action.payload);
        usersId.forEach((userId) => {
          const renterId = action.payload[userId];
          users[userId] = {
            ...users[userId],
            renter_id: renterId,
          };
        });
      }
      return {
        ...state,
        error: null,
        pending: false,
        sending: false,
        content: users,
      };
    }
    case USER_RENTER_REMOVED: {
      let users = {};
      const oldRenterId = action.payload.id;
      if (state.content) {
        users = JSON.parse(JSON.stringify(state.content));
        const foundUserIndex = Object.keys(users).findIndex((userId) => userId === oldRenterId);
        if (foundUserIndex !== -1) {
          users[oldRenterId] = {
            ...users[oldRenterId],
            renter_id: null,
          };
        }
      }
      return {
        ...state,
        error: null,
        pending: false,
        sending: false,
        content: users,
      };
    }
    case USER_DOWNLOADED: {
      const user = action.payload;
      const users = state.content;
      users[action.userId] = user;
      return {
        ...state,
        error: null,
        pending: false,
        sending: false,
        content: users,
      };
    }
    case WAITING_USERS_DOWNLOADED:
      return {
        ...state,
        error: null,
        pending: false,
        sending: false,
        pendingWU: false,
        waitingUsers: action.payload,
      };
    case WAITING_USERS_PENDING:
      return {
        ...state,
        error: null,
        pendingWU: true,
      };
    case WAITING_USER_DOWNLOADED: {
      const waitingUser = action.payload;
      let waitingUsers = [];
      if (state.waitingUsers) {
        waitingUsers = JSON.parse(JSON.stringify(state.waitingUsers));
      }
      if (!waitingUsers.includes(waitingUser)) {
        waitingUsers.push(waitingUser);
      }
      return {
        ...state,
        error: null,
        pending: false,
        sending: false,
        pendingWU: false,
        waitingUsers,
      };
    }
    case WAITING_USER_REMOVED: {
      const waitingUser = action.payload;
      let waitingUsers = [];
      if (state.waitingUsers) {
        waitingUsers = JSON.parse(JSON.stringify(state.waitingUsers));
      }
      waitingUsers.splice(waitingUsers.indexOf(waitingUser));
      return {
        ...state,
        error: null,
        pending: false,
        sending: false,
        pendingWU: false,
        waitingUsers,
      };
    }
    case USERS_FAILED:
      return {
        ...state,
        error: action.payload,
        pending: false,
        sending: false,
      };
    case USER_LOGIN:
      return {
        ...state,
        authUser: action.payload,
      };
    case USER_SENDING:
      return {
        ...state,
        sending: true,
      };
    default:
      break;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/store/users/reducers.js